import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CommonService } from '../../services';
import { PostcodeList, SuburbList } from '../../models/account-delivery-address';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { DOCUMENT } from '@angular/common';
import { Validators } from '@angular/forms';
import { ManageService } from '../../services/manage.service';
import { WGSModifySubscriptionResponse, WGSubscriptionModel } from '../../models/csp.model';
import { FinishWGSCreateComponent } from '../finish-wgs-create/finish-wgs-create.component';



@Component({
  selector: 'app-confirm-wgs-create',
  templateUrl: './confirm-wgs-create.component.html',
  styleUrls: ['./confirm-wgs-create.component.css']
})
export class ConfirmWGSCreateComponent implements OnInit {
  
 
  //confirmSubscriptions: WGSubscriptionModel[];
  loadContent: boolean = false;
  CompanyName='';
  AttentionRef='';
  poReference = '';
  Email = '';
  AddressLine1 ='';
  AddressLine2='';
  AddressLine3='';
  City ='';
  State ='';
  PostCode = '';
  PhoneNumber = '';
  constructor(
    public commonService: CommonService,
    public dialogRef: MatDialogRef<ConfirmWGSCreateComponent>,
    private formBuilder: FormBuilder,
    private manageService: ManageService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data:any,
    @Inject(DOCUMENT) private _document: Document) {    
    this.initialAddress();
    
    this.userFormGroup = this.formBuilder.group({
      poReference : new FormControl("", Validators.required),
      CompanyName : new FormControl("", Validators.required),
      AttentionRef : new FormControl("", Validators.required),
      Email: new FormControl("", this.commonService.emailValidatorRegex()),
      AddressLine1: new FormControl(""),
      AddressLine2: new FormControl(""),
      AddressLine3: new FormControl(""),
      City: new FormControl("", Validators.required),
      State: new FormControl("", Validators.required),
      PostCode: new FormControl("", [Validators.required, Validators.maxLength(4)]),
      PhoneNumber: new FormControl("", Validators.required),     
      
    });
    }
    
    userFormGroup: FormGroup;
    filteredPostCode: PostcodeList[];
    filteredSub: PostcodeList[];
    stateList: string[];
    validationArray: any[] = [
      { field: "poReference", class: "poReference", message: "Please enter PO reference" },
      { field: "CompanyName", class: "wgsCompanyNameValidate", message: "Please enter Company name" },
      { field: "AttentionRef", class: "wgsAttnRefValidate", message: "Please enter Attn/Ref" },
      { field: "Email", class: "wgsEmailValidate", message: "Please enter Email" },
      { field: "AddressLine1", class: "wgsAddressLine1Validate", message: "Please enter adrress" },
      { field: "City", class: "wgsCityValidate", message: "Please enter suburb" },
      { field: "State", class: "wgsStateValidate", message: "Please enter state" },
      { field: "PostCode", class: "wgsPostCodeValidate", message: "Please enter postcode" },
      { field: "PhoneNumber", class: "wgsPhoneNumberValidate", message: "Please enter Phone Number" }
      
    ];
   


   
    @ViewChild('myAutocompleteTriggerSub') private _myAutocompleteTriggerSub: MatAutocompleteTrigger;
    @ViewChild('myAutocompleteTriggerPostcode') private _myAutocompleteTriggerPostcode: MatAutocompleteTrigger;
    
  ngOnInit() {
    this.loadContent = true;
   
  }

  continueSaveSubscription(): void {    


    if (this.userFormGroup.valid) {
      let flag = false;
      if (this.userFormGroup.get("PostCode").value.length < 4) {
        flag = true;
        this.commonService.showValidator('.wgsPostCodeValidate', "Please input valid postcode", "right", "error");
      }
      this.userFormGroup.get("poReference").setValue(this.poReference);
      this.userFormGroup.get("Email").setValue(this.Email);
      this.userFormGroup.get("AddressLine1").setValue(this.AddressLine1);
      this.userFormGroup.get("AddressLine2").setValue(this.AddressLine2);
      this.userFormGroup.get("AddressLine3").setValue(this.AddressLine3);
      this.userFormGroup.get("City").setValue(this.City);
      this.userFormGroup.get("State").setValue(this.State);
      this.userFormGroup.get("PostCode").setValue(this.PostCode);
      this.userFormGroup.get("PhoneNumber").setValue(this.PhoneNumber);
    }
    else{
      /* this.isNotValidField('poReference', this.validationArray.poReference);         
      this.isNotValidField('CompanyName', this.validationArray.companyName);
      this.isNotValidField('AttentionRef', this.validationArray.attnOrRef);
      this.isNotValidField('Email', this.validationArray.eMail);  
      this.isNotValidField('AddressLine1', this.validationArray.addressLine1);
      this.isNotValidField('City', this.validationArray.suburb);
      this.isNotValidField('State', this.validationArray.state);
      this.isNotValidField('PostCode', this.validationArray.postcode);
      this.isNotValidField('PhoneNumber', this.validationArray.phone); */
      this.validationArray.forEach(item => {
        this.validateFields(item);
      }); 
    }
     
    
    if (!this.poReference || !this.CompanyName || !this.AttentionRef || !this.Email || !this.AddressLine1 || !this.City || !this.State || !this.PostCode || !this.PhoneNumber) {
    
      this.commonService.showError('.continue', 'Please provide mandatory data to continue', 'right');
      
     
    } else {
      //this.dialogRef.close(this.poReference);
      if (this.userFormGroup?.value) {
        this.poReference = this.userFormGroup?.value?.poReference?.trim();     
        this.AttentionRef = this.userFormGroup?.value?.AttentionRef;
        this.CompanyName = this.userFormGroup?.value?.CompanyName;  
        this.Email = this.userFormGroup?.value?.Email;
        this.AddressLine1 =this.userFormGroup?.value?.AddressLine1;
        this.AddressLine2 =this.userFormGroup?.value?. AddressLine2;
        this.AddressLine3 = this.userFormGroup?.value?. AddressLine3;
        this.City = this.userFormGroup?.value?.City ;
        this.State = this.userFormGroup?.value?.State;
        this.PostCode =this.userFormGroup?.value?.PostCode ;
        this.PhoneNumber = this.userFormGroup?.value?.PhoneNumber;
        this.loadContent = false;
        if (this.data?.confirmSubscriptions?.length) {
          this.data.confirmSubscriptions.map(item => {
            item.customerReference = this.poReference;
            item.AttentionRef = this.AttentionRef;
            item.CompanyName = this.CompanyName;
            item.Email = this.Email;
            item.AddressLine1 = this.AddressLine1;
            item.AddressLine2 = this.AddressLine2;
            item.AddressLine3 = this.AddressLine3;
            item.City = this.City;
            item.State = this.State;
            item.PostCode = this.PostCode;
            item.PhoneNumber = this.PhoneNumber;          
          });
          this.manageService.addWGSProduct(this.data.confirmSubscriptions).subscribe((res: WGSModifySubscriptionResponse[]) => {
            if (res.length) {
              this.loadContent = true;
              const dialogRefFinish = this.dialog.open(FinishWGSCreateComponent, {
                width: '900px',
                data: { finishSubscriptions: res },
                disableClose: true
              });
      
              dialogRefFinish.afterClosed().subscribe(() => {
                if (res?.every(i => i?.isUpdateSuccessful)) {
                  this.dialogRef.close(res);
                }
              });
            } else {
              this.commonService.implementToast('Something went wrong while cloning', 'Error');
            }
          });

        }
      }

    }
    
    
  }
  validateFields(item: any) {
    
    if (item.field === "Email") {
    /*   if (this.userFormGroup.get(item.field).hasError("required")) {
        this.commonService.showValidator("." + item.class, item.message, "right", "error");
      }  */
      if (this.userFormGroup.get(item.field).hasError("Email")) {
        this.commonService.showValidator("." + item.class, "Please enter a valid email address", "right", "error");
      }
    } /* else {
      if (!this.userFormGroup.get(item.field).valid) {
        this.commonService.showValidator("." + item.class, item.message, "right", "error");
      }
    } */
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  chooseAutoComplete(option: PostcodeList): void {
    this.userFormGroup.get('PostCode').setValue(option.postcode);
    this.userFormGroup.get('State').setValue(option.state);
    this.userFormGroup.get("City").setValue(option.suburb);
  }

  chooseAutoCompletPostcode(event: any): void {
    if (this.filteredPostCode) {
      this.userFormGroup.get('PostCode').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
      this.userFormGroup.get('State').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
      this.userFormGroup.get('City').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
    }
  }

  chooseAutoCompletSuburb(event: any): void {
    if (this.filteredSub) {
      this.userFormGroup.get('PostCode').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
      this.userFormGroup.get('State').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
      this.userFormGroup.get('City').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
    }
  }
  startFilterPostcode(res: PostcodeList[]): void {
    this.filteredPostCode = res;
  }

  startFilterSub(res: PostcodeList[]): void {
    this.filteredSub = res;
  }
  onInputSub(event: any): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerSub._onChange(target.value);
    }
  }
  onInputPostcode(event: any): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerPostcode._onChange(target.value);
    }
  }
  isNumberKey(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  initialAddress(): void {
    this.userFormGroup = this.formBuilder.group({
      userGroup: this.getAddressGroup()
      
    });
  } 
  getAddressGroup(): FormGroup {
    return this.formBuilder.group({      
      poReference : new FormControl('', [Validators.required]),
      CompanyName :new FormControl('', [Validators.required]),
      AttentionRef :new FormControl('', [Validators.required]),
      Email: new FormControl('', [Validators.required]),
      AddressLine1: new FormControl('', [Validators.required]),
      AddressLine2: new FormControl('', []),
      AddressLine3: new FormControl('', []),
      City: new FormControl('', [Validators.required]),
      State: new FormControl('', [Validators.required]),
      PostCode: new FormControl('', [Validators.required]),
      PhoneNumber: new FormControl('', [Validators.required])
     
    });
  }
  isNotValidField(path: string, validation: any): void {
    if (this.userFormGroup.get(path).hasError('required')) {
      this.commonService.showValidator('.' + validation[0].class, validation[0].message, 'right', 'error');
    }
  }
  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }
}
